export const faqs = [
  // Overview
  {
    q: 'What is Bubble Ai and what can it do?',
    a: `Bubble Ai is an AI-powered career assistant (RA1 engine by Blue Spider Technologies Lab). It helps you: figure out your career roadmap, auto-apply to jobs, create ATS-optimized resumes/CVs in finished PDF, tailor cover letters for any job, discover 90%+ interview chance job matches, run interview mocks, simulate professional and academic exams with study plan based on identified weaknesses and real-time AI tutor.`
  },
  {
    q: 'How does Job Automator (Auto-Apply) work?',
    a: `Create or upload a resume, and let Bubble Ai tailor your resume & cover letter, discover recruiter emails (where needed), and send applications automatically. You can start/stop, track progress, and see per-job status. Connect your Gmail easily for higher application deliverability, internal delivery works less reliably without Gmail connection.`
  },
  {
    q: 'What does “90%+ interview chance” mean?',
    a: `We score job matches based on your resume, role fit, and historic signals. “90%+ interview chance connects” are high-fit leads that historically convert better. It’s not a guarantee of outcome, but a strong prioritization signal to save your time.`
  },

  // Plans & pricing
  {
    q: 'Which plans are available (Free, Per Use, Per Week, Per Month)?',
    a: `Free lets you try core features with limits (e.g., 2 resumes lifetime, daily caps). Per Use is one-time resume creation after you have exhausted your free resumes. Per Week unlocks more auto-apply and tools for 7 days with limits. Per Month is the full experience with higher quotas, insider connects, and our interview acceleration toolkit.`
  },
  {
    q: 'What do I get on Per Month?',
    a: `Everything in lower tiers plus: Interview acceleration ("Guaranteed Interviews" program terms), insider connects, deep company insights, 900+ job connections, Auto Apply Agent (extremely high volume), unlimited interview mocks and follow-ups, resume storage and sharing, human career coaching support and much more.`
  },
  {
    q: 'Do subscriptions auto-renew?',
    a: `No. Current subscriptions run for their duration (Per Use/Week/Month) and expire. Renew or upgrade anytime.`
  },
  {
    q: 'Is there a free trial?',
    a: `New users may receive a limited trial. In rare cases (e.g., multiple recent signups from the same individual), trial can be denied or blocked. You can still upgrade to unlock everything immediately.`
  },
  {
    q: 'How are prices determined for my country/currency?',
    a: `We display prices in your currency. For Africa, Nigeria (NGN) uses a base African price; some other African currencies may vary due to regional adjustments. Final checkout shows the exact amount before you pay.`
  },

  // Coupons & payments
  {
    q: 'Can I use a coupon code?',
    a: `Yes. Log in, then apply the coupon during checkout. Codes must match the product (e.g., Job Automator), duration (Per Week/Month), be valid (not expired/maxed), and unused on your account.`
  },
  {
    q: 'Which payment provider do you use?',
    a: `Payments are securely processed by Flutterwave. Your card details never touch our servers (PCI-DSS compliant).` 
  },
  {
    q: 'I paid but didn’t see confirmation—what should I do?',
    a: `Go to the Transaction page if redirected, or check your email for a payment receipt. If it’s still unclear after a few minutes, contact support with your registered email and transaction reference.`
  },
  {
    q: 'Refunds and plan changes',
    a: `Digital services are generally non-refundable once delivered. If you experienced a technical issue and received no value, reach out—we investigate fairly and quickly. You can switch plans at any time; email support for manual adjustments or discounts on upgrades.`
  },

  // Using resumes & cover letters
  {
    q: 'Can Bubble Ai write and optimize my resume and cover letters?',
    a: `Yes. Provide your info or upload a file; Bubble Ai creates an ATS-friendly resume and tailored cover letters for each role. You can edit, pick templates, and download as PDF.`
  },
  {
    q: 'Will Bubble Ai store my resumes?',
    a: `Yes, on paid tiers you get resume storage for later access. You can download, share, and manage them. You can delete them at anytime using the delete button per resume.`
  },

  // Job automation specifics
  {
    q: 'Do I need Gmail for Auto-Apply?',
    a: `While Gmail is optional, it is recommended so your applications look real and sent by you. With it, we can also send applications via your inbox for better deliverability. Without Gmail, we use internal delivery which is less reliable.`
  },
  {
    q: 'Where do the jobs come from?',
    a: `We aggregate quality roles from vetted sources and partner feeds (including company sites). You’ll see location filters like Remote/Hybrid/On-site and country filters for relevance.`
  },
  {
    q: 'How many jobs can I auto-apply to?',
    a: `Depends on your plan. Free/Per Use have low caps; Per Week and Per Month unlock higher volumes (e.g., 30/week and 150/month typical guidance). You can also select multiple jobs to batch-start auto-apply.`
  },

  // “Guaranteed Interviews” clarification
  {
    q: 'What does “Guaranteed Interviews” mean?',
    a: `It’s our interview acceleration commitment on Per Month: we prioritize high-fit connects, tailor assets, and run strategic follow-ups. If you don’t land interviews within an appropriate window, we keep working with you (extended connects, tailored outreach, coach adjustments). It’s not a monetary guarantee but a continued service commitment to help you secure interviews but it has proven extremely successful in past cases.`
  },

  // Limits & quotas
  {
    q: 'What are typical daily/weekly limits?',
    a: `See plans for exact limits.`
  },

  // Account & verification
  {
    q: 'I didn’t receive my verification code—help?',
    a: `Check spam, wait up to 60 seconds, then tap Resend. If you still don’t see it, ensure your email address is correct. Last resort—contact support with your email.`
  },
  {
    q: 'After verification, how do I get the 60% OFF offer?',
    a: `Click “View 60% OFF” or go to pricing—this scrolls directly to plans. Pick Per Month to unlock the full Job Automator experience.`
  },

  // Security & privacy
  {
    q: 'Is my data secure?',
    a: `Yes. We use SSL/TLS for data in transit, trusted PCI-DSS compliant payment providers for billing, rate-limited analytics with minimal payloads, and strict in‑house practices. Sensitive tokens are used only to authenticate your requests.`
  },
  {
    q: 'What data can I delete?',
    a: `You can delete your resumes and content you created. For account or data deletion, email support from your registered address and we’ll process your request.`
  },

  // Exam Simulator
  {
    q: 'Does Bubble Ai have an Exam Simulator? How does it work?',
    a: `Yes. The Exam Simulator lets you practice with real past questions, real timing, real exam blueprints and rubrics etc. Tell Bubble Ai the exam, start a timed session, answer questions, then see your score, corrections and study plan tailored for you to save you time and guide you with exam specific tricks.`
  },
  // Referrals & earnings
  {
    q: 'Can I earn by referring friends?',
    a: `Yes—visit the Referral Hub in your dashboard to get your link and see earnings. We attribute qualifying purchases to your account and pay out as per the program rules.`
  },
  // Support
  {
    q: 'How do I contact support?',
    a: `Use the in-app chat (Help widget) or email support@bubble-ai.tech from your registered email. Include screenshots, error messages, and your transaction reference (if billing-related) for faster help.`
  }
]